import { CONTACT_US_ADDRESS_MAIN, CONTACT_US_EMAIL_MAIN, CONTACT_US_PHONE_MAIN, CONTACT_US_WHATSAPP_MAIN, SITE_TITLE } from '../../shared/constants';
import CONTACT_US_WORKING_HOURS from './content/working-hours.content.html';

import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ContactusFormComponent } from '../contactus-form/contactus-form.component';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatToolbarModule } from '@angular/material/toolbar';
import { Meta, Title } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-contact',
  imports: [
    ContactusFormComponent,
    MatButtonModule,
    MatCardModule,
    MatToolbarModule,
    RouterModule
],
  templateUrl: './contact.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './contact.component.scss'
})
export class ContactComponent {

  constructor(private meta: Meta, private title: Title) { }

  CONTACT_US_ADDRESS_MAIN: string = CONTACT_US_ADDRESS_MAIN
  CONTACT_US_EMAIL_MAIN: string = CONTACT_US_EMAIL_MAIN
  CONTACT_US_PHONE_MAIN: string = CONTACT_US_PHONE_MAIN
  CONTACT_US_WHATSAPP_MAIN: string = CONTACT_US_WHATSAPP_MAIN
  CONTACT_US_WORKING_HOURS: string = CONTACT_US_WORKING_HOURS

  showMainAddress: Boolean = true
  showPhoneMain: Boolean = true
  showWhatsAppMain: Boolean = true
  showMainAddressGoogleMap: Boolean = true

  ngOnInit(): void {
    this.title.setTitle(SITE_TITLE + ' | Contact us!');
    this.meta.updateTag({ name: 'description', content: 'Contact nordnative for any questions.' });
    this.meta.updateTag({ name: 'keywords', content: 'Contact nordnative, nordnative support, Nord Native contact, sales automation, marketing automation' });
  }
}
